/**
 * FOR PRODUCTION
 */

const keys = {
  dashboardStatusUrl: "https://agile-ocean-79433.fly.dev/dashboard/stats",
  deleteObjectUrl: "https://agile-ocean-79433.fly.dev/dashboard/delete-object",
  updateObjectUrl: "https://agile-ocean-79433.fly.dev/dashboard/update-object",
  getMusicUrl: "https://agile-ocean-79433.fly.dev/get-music",
  musicUrl: "https://agile-ocean-79433.fly.dev/music",
  uploadUrl: "https://agile-ocean-79433.fly.dev/upload",
  signInUrl:
    "https://qeyrfqi5id.execute-api.us-east-1.amazonaws.com/dev/users/sign-in",
  mailchimpSignUpUrl: "https://agile-ocean-79433.fly.dev/users/email/signup",
};

/**
 * for development
 */

// const keys = {
//   dashboardStatusUrl: "http://localhost:5000/dashboard/stats",
//   deleteObjectUrl: "http://localhost:5000/dashboard/delete-object",
//   updateObjectUrl: "http://localhost:5000/dashboard/update-object",
//   getMusicUrl: "http://localhost:5000/get-music",
//   musicUrl: "http://localhost:5000/music",
//   uploadUrl: "http://localhost:5000/upload",
//   signInUrl:
//     "https://qeyrfqi5id.execute-api.us-east-1.amazonaws.com/dev/users/sign-in",
//   verifyEmailUrl:
//     "https://qeyrfqi5id.execute-api.us-east-1.amazonaws.com/dev/users/verify-email",
//   mailchimpSignUpUrl: "http://localhost:5000/users/email/signup"
// };

export default keys;



// WEBPACK FOOTER //
// ./src/config/index.js